import React, { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { PatentPopup } from '../../assets/images';

const linkSx = {
  color: 'var(--qc-shell-muted, #a9b5ca)',
  textDecoration: 'none',
  font: 'inherit',
  fontSize: '0.82rem',
  lineHeight: 1.25,
  background: 'none',
  border: 0,
  padding: 0,
  margin: 0,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
};

export default function ProfileFooter(): JSX.Element {
  const [patentOpen, setPatentOpen] = useState(false);
  const [privacyOpen, setPrivacyOpen] = useState(false);

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto', pt: 2, textAlign: 'center', width: '100%', minWidth: 0,
      }}
    >
      <Box
        sx={{
          width: '100%',
          minWidth: 0,
          overflowX: 'auto',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': { display: 'none' },
        }}
      >
        <Stack
          direction="row"
          useFlexGap
          flexWrap="nowrap"
          justifyContent="center"
          alignItems="center"
          sx={{ width: 'max-content', minWidth: '100%', columnGap: 2.75 }}
        >
          <Link to="/about-us" style={linkSx}>About us</Link>
          <Link to="/privacy-policy" style={linkSx}>Privacy Policy</Link>
          <Link to="/cookie-policy" style={linkSx}>Cookie Policy</Link>
          <Box component="button" type="button" sx={linkSx} onClick={() => setPatentOpen(true)}>
            Patents
          </Box>
          <Link to="/terms-and-conditions" style={linkSx}>Terms of Service</Link>
          <Link to="/trust-policy" style={linkSx}>Trust Policy</Link>
          <Box component="button" type="button" sx={linkSx} onClick={() => setPrivacyOpen(true)}>
            Do Not Sell My Personal Information
          </Box>
        </Stack>
      </Box>
      <Typography sx={{ mt: 1, fontSize: '0.82rem', lineHeight: 1.25, color: 'var(--qc-shell-muted, #a9b5ca)' }}>
        © Copyright 2026 QuickCam, LLC. All rights reserved.
      </Typography>
      <Dialog open={patentOpen} onClose={() => setPatentOpen(false)} maxWidth="md">
        <DialogTitle>QuickCam patents</DialogTitle>
        <DialogContent>
          <Box
            component="img"
            src={PatentPopup}
            alt="QuickCam patent information"
            sx={{ display: 'block', maxWidth: '100%', height: 'auto' }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPatentOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
      <Dialog open={privacyOpen} onClose={() => setPrivacyOpen(false)}>
        <DialogTitle>Do Not Sell My Personal Information</DialogTitle>
        <DialogContent>
          <Typography>
            Confirm that you want QuickCam to record this opt-out preference on this device.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPrivacyOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={() => {
              window.localStorage.setItem('isPersonalInformationSell', 'true');
              setPrivacyOpen(false);
            }}
          >
            Confirm opt-out
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
